// extracted by mini-css-extract-plugin
export default {"zoomModal":"y1-z","image":"z1-z","button":"A1-z","isOverlayShown":"B1-z"};